/**
 * Created by andrey on 01.08.2022
 */

// eslint-disable-next-line
let HideAnimations = function (f) {
    f();
};